import { RequiredDesignFileTemplateBody } from './required-design-file-template-body.model';

export interface RequiredDesignFileTemplatePreviewMatchRequest {
    readonly treatmentId: string;
}

export interface RequiredDesignFileTemplatePreviewMatchResult {
    readonly templateId: number;
    readonly templateName: string;
    readonly score: number;
    readonly hasConflict: boolean;
    readonly conflictingTemplateIds: readonly number[];
    readonly body: RequiredDesignFileTemplateBody;
}
